// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__2KATf","placeholder":"icon_placeholder__1r0p0","search":"icon_search__3-4YO","teamIconWrapper":"icon_teamIconWrapper__1VGpG","teamIcon":"icon_teamIcon__BEUYj"};